'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	reconnectDelay = 1000,
	EVENT = {
		message: 'message',
		protocolError: 'protocolError',
		error: 'error',
		close: 'close'
	};
module.exports = function WebSocketShim({navigatorShim}) {
	if (!navigatorShim || typeof navigatorShim.buildWebSocket !== 'function') {
		throw new Error('invalid-args');
	}
	let socket, lastParams;
	const self = observable(this),
		listeners = {
			close: async () => {
				socket = false;
				if (lastParams && navigatorShim.isOnline()) {
					await navigatorShim.delay(reconnectDelay);
					self.start(lastParams.websocketUrl, lastParams.params);
				}
			},
			message: event => {
				try {
					const jsonMessageBody = JSON.parse(event.data);
					self.dispatchEvent(EVENT.message, jsonMessageBody);
				} catch (e) {
					self.dispatchEvent(EVENT.protocolError, e, 'dataDeserializationError');
				}
			},
			error: (event) => {
				self.dispatchEvent(EVENT.error, event, 'socketError');
			}
		},
		closeSocket = () => {
			if (socket) {
				lastParams = false;
				Object.keys(listeners).forEach(key => {
					try {
						socket.removeEventListener(key, listeners[key]);
					} catch (e) {
						self.dispatchEvent(EVENT.error, e, {removeEventListener: key});
					}
				});
				try {
					socket.close();
					self.dispatchEvent(EVENT.close);
				} catch (e) {
					self.dispatchEvent(EVENT.error, e, 'closeSocketError');
				}
				socket = false;
			}
		};

	self.start = async (websocketUrl, params) => {
		if (!websocketUrl || typeof websocketUrl !== 'string') {
			throw new Error('invalid-args');
		}
		closeSocket();
		const webSocketUrl = navigatorShim.encodeUrlParams(websocketUrl, params);
		socket = await navigatorShim.buildWebSocket(webSocketUrl);
		lastParams = {websocketUrl, params};
		Object.keys(listeners).forEach(key => socket.addEventListener(key, listeners[key]));
	};
	self.isOpen = () => socket && (socket.readyState === socket.OPEN);
	self.stop = closeSocket;
	self.send = (data) => {
		if (!socket) {
			const error = new Error('invalid-socket');
			self.dispatchEvent(EVENT.error, error, 'sendingDataWithNoSocketError');
			throw error;
		}
		try {
			socket.send(JSON.stringify({action: 'clientmessage', data}));
		} catch (e) {
			self.dispatchEvent(EVENT.error, e, 'sendingDataError');
			throw e;
		}
	};
	navigatorShim.addEventListener('network-status', isOnline => {
		if (lastParams && isOnline && !self.isOpen()) {
			return self.start(lastParams.websocketUrl, lastParams.params);
		}
	});
};

